import { Helmet } from 'react-helmet-async';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  name: 'Opciones Argentinas',
  url: 'https://nocheydiaturismo.com',
  logo: 'https://nocheydiaturismo.com/favicon.ico',
  description: 'Agencia de turismo líder en salidas grupales desde 1993. Paquetes nacionales e internacionales.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'AR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    url: 'https://nocheydiaturismo.com/contacto',
  },
};

function OrganizationSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export default OrganizationSchema;
